export default {
    nav: {
        profile: "Profile",
        information: "Information"
    },
    profile: {
        title: "Change avatar",
        buttons: {
            logout: "Logout",
            change_password: "Change password",
            events: "events"
        }
    },
    information: {
        count: ({count}) => `Number of messages : ${count}`
    }
}